import * as Yup from 'yup';

import { EMAIL_INVALID, requiredMsg } from 'lib/constants/messages';

const customValidationSchema = Yup.object().shape({
  customContact: Yup.string().when('contactType', {
    is: 'email',
    then: () => Yup.string().email(EMAIL_INVALID).required(requiredMsg('Email')),
    otherwise: () =>
      Yup.string()
        .matches(/^[0-9]+$/, 'Enter a valid phone number')
        .required(requiredMsg('Phone number'))
  }),
  secondaryContact: Yup.string().when('contactType', {
    is: 'email',
    then: () => Yup.string().email(EMAIL_INVALID),
    otherwise: () => Yup.string().matches(/^[0-9]+$/, 'Enter a valid phone number')
  })
});

export default customValidationSchema;
